import React from 'react';
import { useHistory } from 'react-router-dom';
import './BackBtn.less';

export default function BackBtn(props) {
  const history = useHistory();
  const clickHandler = props.onClick || (() => history.goBack());

  return (
    <div className="back-btn">
      <button type='button' onClick={clickHandler}>Вернуться назад</button>
    </div>
  );
}
